(function () {
  if (window.__vlColorScrollInit) return;
  window.__vlColorScrollInit = true;

  document.addEventListener('change', function (event) {
    var input = event.target;
    if (!input.matches || !input.matches('input[type="radio"], select')) return;

    var optionFieldset = input.closest('[data-option-name="color"]');
    if (!optionFieldset) return;

    var section = input.closest('.shopify-section');
    var gallery = section ? section.querySelector('media-gallery') : document.querySelector('media-gallery');
    if (!gallery) return;

    var rect = gallery.getBoundingClientRect();
    var fullyVisible = rect.top >= 0 && rect.bottom <= window.innerHeight;
    if (!fullyVisible) {
      gallery.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  });
})();
